const state = {
  graphicsData: null,
  csvFile: null,

  regressionSummary: null,
  aicFile: null,

  mod1Files: [],
  mod2Files: [],
  mod3Files: [],
  mod4Files: [],

  reportFile: null
}

const getters = {
  graphicsData: (state) => state.graphicsData,
  csvFile: (state) => state.csvFile,

  regressionSummary: (state) => state.regressionSummary,
  aicFile: (state) => state.aicFile,

  mod1Files: (state) => state.mod1Files,
  mod2Files: (state) => state.mod2Files,
  mod3Files: (state) => state.mod3Files,
  mod4Files: (state) => state.mod4Files,
  reportFile: (state) => state.reportFile
}

const mutations = {
  SET_GRAPHICS_DATA (state, graphicsData) {
    state.graphicsData = graphicsData
  },
  SET_CSV_FILE (state, csvFile) {
    state.csvFile = csvFile
  },

  SET_REGRESSION_SUMMARY (state, regressionSummary) {
    state.regressionSummary = regressionSummary
  },
  SET_AIC_FILE (state, aicFile) {
    state.aicFile = aicFile
  },

  SET_MOD1_FILES (state, mod1Files) {
    state.mod1Files = mod1Files
  },
  SET_MOD2_FILES (state, mod2Files) {
    state.mod2Files = mod2Files
  },
  SET_MOD3_FILES (state, mod3Files) {
    state.mod3Files = mod3Files
  },
  SET_MOD4_FILES (state, mod4Files) {
    state.mod4Files = mod4Files
  },

  SET_REPORT_FILE (state, reportFile) {
    state.reportFile = reportFile
  },

  CLEAR_CURRENT_PROCESS (state) {
    state.graphicsData = null
    state.csvFile = null

    state.regressionSummary = null
    state.aicFile = null

    state.mod1Files = []
    state.mod2Files = []
    state.mod3Files = []
    state.mod4Files = []
  }
}

const actions = {
  clearCurrentProcess ({ commit }) {
    try {
      commit('CLEAR_CURRENT_PROCESS')
    } catch (e) {
      console.error(e)
    }
  },

  setMod1Results ({ commit }, data) {
    try {
      commit('SET_MOD1_FILES', data)
    } catch (e) {
      console.error(e)
    }
  },

  setMod2Results ({ commit }, data) {
    try {
      commit('SET_GRAPHICS_DATA', data.graphicsData)
      commit('SET_CSV_FILE', data.csvFile)
      commit('SET_MOD2_FILES', data.mod2Files)
    } catch (e) {
      console.error(e)
    }
  },

  setMod3Results ({ commit }, data) {
    try {
      commit('SET_REGRESSION_SUMMARY', data.regressionSummary)
      commit('SET_AIC_FILE', data.aicFile)
      commit('SET_MOD3_FILES', data.mod3Files)
    } catch (e) {
      console.error(e)
    }
  },

  setMod4Results ({ commit }, data) {
    try {
      commit('SET_MOD4_FILES', data)
    } catch (e) {
      console.error(e)
    }
  },

  setReportFile ({ commit }, data) {
    try {
      commit('SET_REPORT_FILE', data)
    } catch (e) {
      console.error(e)
    }
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
